// extracted by mini-css-extract-plugin
module.exports = {"left":"UW5zJ","right":"_3BPsU","row":"_14fi4","avatarHeader":"_27Ijx","titleHeader":"Gr8_8","iconHeader":"_3mnDD","timeAgoHeader":"_3PSN_","moreButtonHeader":"_2SJcQ"};